document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-ss-faq-toggle]');
  if (!button) return;

  const item = button.closest('.ss-faq__item');
  if (!item) return;

  const isOpen = item.classList.contains('is-open');
  item.closest('.ss-faq__list')?.querySelectorAll('.ss-faq__item.is-open').forEach((openItem) => {
    if (openItem !== item) {
      openItem.classList.remove('is-open');
      openItem.querySelector('[data-ss-faq-toggle]')?.setAttribute('aria-expanded', 'false');
    }
  });

  item.classList.toggle('is-open', !isOpen);
  button.setAttribute('aria-expanded', String(!isOpen));
});
